import { render, staticRenderFns } from "./ChangeVersion.vue?vue&type=template&id=0602638c"
import script from "./ChangeVersion.vue?vue&type=script&lang=js"
export * from "./ChangeVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports